import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { TranslocoService } from '@ngneat/transloco';

@Injectable({
  providedIn: 'root',
})
export class AuthUtilService {
  translate = (key: string | string[], params?: Record<string, string>, lang?: string) =>
    this.translocoService.translate(key, params, lang);

  constructor(private translocoService: TranslocoService) {}

  getErrorMessage(error: HttpErrorResponse) {
    let message: string;
    let title: string;

    const errorMessage: string = error?.error?.message?.toLowerCase() ?? '';

    if (error.status >= 500) {
      title = this.translate('auth.login.error_messages.server_error.title');
      message = this.translate('auth.login.error_messages.server_error.message');
    } else if (errorMessage.includes('invalid-password')) {
      title = this.translate('auth.login.error_messages.title');
      message = this.translate('auth.login.error_messages.invalid_password_401');
    } else if (errorMessage.includes('user-not-found')) {
      title = this.translate('auth.login.error_messages.title');
      message = this.translate('auth.login.error_messages.user_not_found_401');
    } else {
      title = this.translate('auth.login.error_messages.title');
      message = this.translate('auth.login.error_messages.not_authorized_403');
    }

    return { title, message };
  }
}
